import { MODAL_EVENT_UPDATE_SERVICES } from '@/consts/app'
import { devLog } from '@/utils'

/**
 * Ce mixin permet de notifier la modification de donnée des services
 * @deprecated On va mettre ça dans le store plus tard...
 */
export default {
  /**
   * @type {string|array}
   */
  DATA_KEY: 'services',
  /**
   * @type {string|array}
   */
  EVENT_NAME: MODAL_EVENT_UPDATE_SERVICES,
  created () {
    const { EVENT_NAME, DATA_KEY } = this.$options
    const dataKeys = Array.isArray(DATA_KEY)
      ? DATA_KEY
      : [DATA_KEY]
    this.registredEvents = []
    ;(Array.isArray(EVENT_NAME)
      ? EVENT_NAME
      : [EVENT_NAME]).forEach((key, i) => {
      const dataKey = dataKeys[i]
      if (!dataKey) {
        return devLog('error', `DATA_KEY doit contenir une clé de mise à jour pour ${key}`)
      }
      const event = {
        key,
        handler: (data) => {
          this._onRefresh(dataKey, data)
        }
      }
      this.registredEvents.push(event)
      this.$ui.$on(event.key, event.handler)
    })
  },
  beforeDestroy () {
    (this.registredEvents || []).forEach((event) => {
      this.$ui.$off(event.key, event.handler)
    })
  },
  methods: {
    _onRefresh (dataKey, data = []) {
      this.onRefresh(dataKey, data)
    },
    onRefresh (dataKey, data = [], unshift = false) {
      const newData = [..._.get(this, dataKey)]
      data.forEach(({ _deleted, ..._s }) => {
        const i = newData.findIndex((s) => s.id === _s.id)
        if (i === -1) {
          if (!_deleted) {
            if (unshift) {
              newData.unshift(_s)
            } else {
              newData.push(_s)
            }
          }
        } else {
          if (_deleted) {
            newData.splice(i, 1)
          } else {
            newData.splice(i, 1, _s)
          }
        }
      })
      _.set(this, dataKey, newData)
    }
  }
}
